<template>
    <div>
      <v-data-table :items="table3Budget" :headers="headersSectionDetailsLines" class="table" :search="searchTable"
      style="height: 100%;"
          rows-per-page-text="100" hide-actions>
          <template slot="items" scope="props">
            <tr :active="props.selected" @click="props.selected = !props.selected">
              <td class="text-xs-left cut-text" style="padding-left:10px">{{ props.item['Nombre'] }}</td>
              <td
                :class="props.item['Nombre'] == 'Siniestralidad Comercial (52 semanas atrás)' ? (props.item['Corporativo'] > 55 ? 'text-xs-center cut-text textRedtd' : 'text-xs-center cut-text textBluetd') : 'text-xs-center cut-text'">
                {{  props.item['Nombre'] ==  'Siniestralidad Comercial (52 semanas atrás)' ?  Number( props.item['Corporativo']).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) + "%"  :  Number( props.item['Corporativo']).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}}</td>
              <td
                :class="props.item['Nombre'] == 'Siniestralidad Comercial (52 semanas atrás)' ? (props.item['CuentasPublicas'] > 55 ? 'text-xs-center cut-text textRedtd' : 'text-xs-center cut-text textBluetd') : 'text-xs-center cut-text'">
                {{ props.item['Nombre'] ==  'Siniestralidad Comercial (52 semanas atrás)' ? Number( props.item['CuentasPublicas']).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) + "%"  : Number( props.item['CuentasPublicas']).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</td>
              <td
                :class="props.item['Nombre'] == 'Siniestralidad Comercial (52 semanas atrás)' ? (props.item['Garantias'] > 55 ? 'text-xs-center cut-text textRedtd' : 'text-xs-center cut-text textBluetd') : 'text-xs-center cut-text'">
                {{ props.item['Nombre'] ==  'Siniestralidad Comercial (52 semanas atrás)' ?   Number( props.item['Garantias']).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) + "%" : Number( props.item['Garantias']).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</td>
              <td
                :class="props.item['Nombre'] == 'Siniestralidad Comercial (52 semanas atrás)' ? (props.item['Individuales'] > 55 ? 'text-xs-center cut-text textRedtd' : 'text-xs-center cut-text textBluetd') : 'text-xs-center cut-text'">
                {{ props.item['Nombre'] ==  'Siniestralidad Comercial (52 semanas atrás)' ?  Number( props.item['Individuales']).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})  + "%"  : Number( props.item['Individuales']).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})  }}</td>
              <td
                :class="props.item['Nombre'] == 'Siniestralidad Comercial (52 semanas atrás)' ? (props.item['Masivos'] > 55 ? 'text-xs-center cut-text textRedtd' : 'text-xs-center cut-text textBluetd') : 'text-xs-center cut-text'">
                {{ props.item['Nombre'] ==  'Siniestralidad Comercial (52 semanas atrás)' ? Number(  props.item['Masivos']).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) + "%"  : Number( props.item['Masivos']).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})   }}</td>
               
 
              <td
                :class="props.item['Nombre'] == 'Siniestralidad Comercial (52 semanas atrás)' ? (props.item['Total'] > 55 ? 'text-xs-center cut-text textRedtd' : 'text-xs-center cut-text textBluetd') : 'text-xs-center cut-text'">
                {{ props.item['Nombre'] ==  'Siniestralidad Comercial (52 semanas atrás)' ?   Number(props.item['Total']).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) + "%"  :  Number(props.item['Total']).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})  }}</td>
            
             
              
              
            
            </tr>
          </template>
          <template slot="no-data">
            <div>{{ noRecordsMessage}}</div>
          </template>
        </v-data-table>

    </div>
  </template>
  
  <script>
  import { i18n } from "@/main";
  export default {
    props: {
      table3Budget: Array,
      searchTable: String,
      noRecordsMessage: String,
    },
    data() {
      return {
        headersSectionDetailsLines: [
        {
          align: "center",
          sortable: false,
          text: "",
          value: "Nombre",
          width: "18%"
        },
        {
          align: "center",
          sortable: false,
          text: i18n.t("message.corporate"),
          value: "Corporativo",
          width: "14%",
          class: "table-header"
        },
        {
          align: "center",
          sortable: false,
          text: i18n.t("message.publicAccounts"),
          value: "CuentasPublicas",
          width: "14%",
          class: "table-header"
        },
        {
          align: "center",
          sortable: false,
          text: i18n.t("message.guarantee"),
          value: "Garantias" ,
          width: "14%",
          class: "table-header"
        },
        {
          align: "center",
          sortable: false,
          text: i18n.t("message.individuals"),
          value: "Individuales",
          width: "14%",
          class: "table-header"
        },
        {
          align: "center",
          sortable: false,
          text: i18n.t("message.massive"),
          value: "Masivos",
          width: "14%",
          class: "table-header"
        },
        {
          align: "center",
          sortable: false,
          text: i18n.t("message.total"),
          value: "Total",
          width: "14%",
          class: "table-header"
        }
      ]
      };
    },
    methods: {
      // Otros métodos del componente hijo si es necesario
    },
  };
  </script>
  
  <style lang="scss">
$header-table: #3AA9E0;
$principal-items: #000349 !default;
$grayColor: #dddddd !default;
$colorBlueTd: #a4cde8;
$colorRedTd: #e5a2c3;
$coloryellowTd: #fffb89;
$whiteColor: white;

.v-label.v-label--active.theme--light.white--text {
  color: $principal-items;
  caret-color: #fff !important;
}

.white--text {
  /* color: #fff !important; */
  color: $principal-items !important;
  caret-color: #fff !important;
}

table tr>td:first-child {
  border-left: 1px solid $grayColor;
  color: $principal-items;
  font-size: medium;
}

.table {
  border: 1px solid $grayColor;
  background-color: transparent !important;
}

.v-table tr:hover:not(.v-table__expanded__content) {
  background: transparent !important;
}

.table th+th {
  border-left: 1px solid $grayColor;
}

.table td+td {
  border-left: 1px solid $grayColor;
}

.table-header {
  background-color: $header-table;
}

.theme--light .v-table thead th {
  color: $whiteColor;
  font-size: 14px;
}

.colorbluetd {
  background-color: $colorBlueTd;
}

.colorRedtd {
  background-color: $colorRedTd;
}

.coloryellowtd {
  background-color: $coloryellowTd;
}
.textBluetd {
  color: $principal-items;
}
.textRedtd {
   color: red;
}



.colorwhitetd {
  background-color: white;
}

@media only screen and (min-width: 1264px) {
  .container {
    max-width: 100%;
  }

}
</style>
  